import React from 'react';

export const CheckSVG: JSX.Element = (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.28609 11.429L16.001 1.7138L14.2866 0.00012207L6.28609 8.00009L1.71439 3.42542L0 5.14268L6.28609 11.429Z"
      fill="#329572"
    />
  </svg>
);
